import React from "react";
import { EstadoContenido } from "../../../../utils/constants";
import { ConfiguracionLogosPage } from "..";

const LogosPorAprobarPage = () => (
  <ConfiguracionLogosPage estado={EstadoContenido.EnAprobacion} />
);

export default LogosPorAprobarPage;
